import styled from "styled-components";

const ModalStyle = styled.div``;
export default ModalStyle;
